import type { FC } from 'react';
import type { PreDrillUserSelectedZone } from 'types/api-responses';
import { pctScore } from './utils';
import { TargetZoneTile, zoneMetricFields, asNum } from './target-zone-tile';

interface TargetZoneUserSelectedTileProps {
  zone: PreDrillUserSelectedZone;
}

// "User Selected" card for a manually-picked target zone — a thin adapter over
// TargetZoneTile: "Manual" tag, confidence "N/A" unless scored.
export const TargetZoneUserSelectedTile: FC<
  TargetZoneUserSelectedTileProps
> = ({ zone }) => {
  const confidence = asNum(zone.confidence);
  return (
    <TargetZoneTile
      eyebrow="User Selected"
      tag={{ label: 'Manual', type: 'teal' }}
      name={zone.name ?? '—'}
      fields={zoneMetricFields({
        topTvdFt: zone.depthRange?.topTvdFt,
        bottomTvdFt: zone.depthRange?.bottomTvdFt,
        thicknessFt: zone.thicknessFt,
        offsetsInZone: zone.offsetsInZone,
        nearbyPermitsInZone: zone.nearbyPermitsInZone,
      })}
      confidence={confidence !== null ? pctScore(confidence) : 'N/A'}
      breakdown={zone.breakdown}
    />
  );
};
